<template>
  <MeasureDetailsModal
    v-if="showMeasureDetailsModal"
    :measureId="measureIdSelected"
    @closeModal="closeModal"
  />
  <MeasureAvaliationModal
    v-if="showMeasureAvaliationModal"
    :measureId="measureIdSelected"
    @closeModal="closeModal"
  />
  <div v-if="measures.length > 0" class="table-responsive mt-3">
    <table class="table table-sm table-striped">
      <thead>
        <tr>
          <th class="text-center">Status</th>
          <th>Usuário</th>
          <th>Data da Medição</th>
          <th>Última Atualização</th>
          <th class="text-center">Valor</th>
          <th class="text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="measure in measures" :key="measure.id">
          <td
            v-html="measureStatus(measure.status, measure.name)"
            class="text-center"
          />
          <td>{{ measure.user }}</td>
          <td>{{ dateTimeSqlToDateTimeBR(measure.createdAt) }}</td>
          <td>
            {{
              measure.updatedAt
                ? dateTimeSqlToDateTimeBR(measure.updatedAt)
                : ''
            }}
          </td>
          <td class="text-center">
            {{ formatToCurrencyBr(measure.totalValue) }}
          </td>
          <td class="text-end">
            <button
              v-if="
                user.codUsuario === measure.user &&
                (measure.status === MeasureStatusEnum.AGUARDANDO_APROVACAO ||
                  measure.status === MeasureStatusEnum.REPROVADO)
              "
              class="btn badge bg-warning my-1"
              title="Editar"
              @click="editMeasure(measure.id)"
            >
              Editar
            </button>
            <button
              v-if="
                measure.status === MeasureStatusEnum.AGUARDANDO_APROVACAO ||
                measure.status === MeasureStatusEnum.APROVADO_GESTOR
              "
              class="btn badge bg-info my-1 ms-2"
              title="Avaliar"
              @click="avaliationMeasure(measure.id)"
            >
              Avaliar
            </button>
            <button
              v-if="
                measure.status == MeasureStatusEnum.AGUARDANDO_APROVACAO &&
                measure.ategPcTecId > 0 &&
                useSeven
              "
              class="btn badge bg-success my-1 ms-2"
              title="Aprovação Automática"
              :disabled="disableButton === measure.id"
              @click="autoApproveMeasure(measure.id)"
            >
              <span v-if="disableButton === measure.id">Processando...</span>
              <span v-else>Aprovação Automática</span>
            </button>
            <button
              class="btn badge bg-primary my-1 ms-2"
              title="Detalhar"
              @click="detailsMeasure(measure.id)"
            >
              Detalhar
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <p v-else class="text-center mt-3 mb-0">Nenhuma medição ainda cadastrada</p>
</template>

<script>
import MeasureDetailsModal from '@/components/documents/commons/MeasureDetailsModal.vue'
import MeasureAvaliationModal from '@/components/documents/commons/MeasureAvaliationModal.vue'
import { mapGetters } from 'vuex'
import MeasureStatusEnum from '@/enum/measureStatusEnum'
import { formatToCurrencyBr } from '@/utils/currency'
import { dateTimeSqlToDateTimeBR } from '@/utils/date'
import { measureStatus } from '@/utils/status'

export default {
  name: 'MeasuresContract',

  props: {
    measures: {
      type: Array,
      required: false,
    },
  },

  components: {
    MeasureDetailsModal,
    MeasureAvaliationModal,
  },

  emits: ['getMeasures'],

  data() {
    return {
      showMeasureDetailsModal: false,
      showMeasureAvaliationModal: false,
      measureIdSelected: null,
      measureStatus,
      formatToCurrencyBr,
      dateTimeSqlToDateTimeBR,
      MeasureStatusEnum,
      disableButton: null,
    }
  },

  computed: {
    ...mapGetters(['user', 'useSeven']),
  },

  methods: {
    editMeasure(measureId) {
      this.$router.push({
        name: 'MeasureEdit',
        params: {
          id: measureId,
        },
      })
    },

    avaliationMeasure(measureId) {
      this.measureIdSelected = measureId
      this.showMeasureAvaliationModal = true
    },

    async autoApproveMeasure(measureId) {
      try {
        this.disableButton = measureId

        const response = await this.$store.dispatch(
          'autoApproveMeasure',
          measureId,
        )

        this.$root.$refs.notification.success(response.message)
        this.$emit('getMeasures')
        this.disableButton = null
      } catch (error) {
        this.disableButton = null
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    detailsMeasure(measureId) {
      this.measureIdSelected = measureId
      this.showMeasureDetailsModal = true
    },

    closeModal(reloadListMeasures) {
      if (reloadListMeasures) {
        this.$emit('getMeasures')
      }
      this.showMeasureDetailsModal = false
      this.showMeasureAvaliationModal = false
    },
  },
}
</script>
